import React, { useContext, useState, useEffect } from "react";
import { NavLink, Link, useLocation, withRouter } from "react-router-dom";
import logo from "../assets/images/logo64.png";
import { FaRegBookmark } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { HiMenu } from "react-icons/hi";
import { GoSignOut } from "react-icons/go";
import { BsFillPersonFill } from "react-icons/bs";
import ParameterContext from "../context/parameter/parameterContext";
import Auth from "./auth/Auth";
import AuthContext from "../context/auth/authContext";
import CryptoContext from "../context/crypto/cryptoContext";
import { IoMdClose } from "react-icons/io";
import {
  saveSearchedItemInLocalStorage,
  getSearchedItemsFromLocalStorage,
} from "../helpers/useLocalStorage";
import { Toaster } from "react-hot-toast";
import { socket, socket_leaderboard } from "../services/socket";

const Appbar = ({ location, history }) => {
  const { modal, toggleModal } = useContext(ParameterContext);
  const {
    userData,
    logoutUser,

    getUser,
    favouriteCoins,
  } = useContext(AuthContext);
  const {
    searchCoins,
    filteredCryptoData,

    getGlobalTicker,
  } = useContext(CryptoContext);

  const [openDropdown, setOpenDropdown] = useState(false);
  const [openMoreDropdown, setOpenMoreDropdown] = useState(false);
  const [coinQuery, setCoinQuery] = useState("");
  const [displayBlock, setDisplayBlock] = useState("none");
  const [openSearch, setOpenSearch] = useState(false);
  const [close, setClose] = useState(true);
  const [searchedItems, setSearchedItems] = useState([]);
  const [show, setShow] = useState(true);

  useEffect(() => {
    //connect to socket and fetch coins in Cryptos Page
    socket_leaderboard.on("connect", () => {
      console.log("connected");
    });
    socket.on("connect", () => {
      console.log("connected");
    });
    getGlobalTicker();

    //on Opening, check if userData exists or not, if Exists call Api
    if (userData || !localStorage.fcmToken) {
      getUser();
    }
  }, []);

  // useEffect(() => {
  // requestPermission(userData.profile_data._id)
  // if(localStorage.token&&localStorage.fcmToken){
  //   fireNotification(localStorage.fcmToken)
  // }
  // getUser();
  // }, []);

  useEffect(() => {
    // if (location.pathname.split("/", 3).join("/") === "/mobile/graph") {
    //   setShow(false);
    // }
    if (location.state) {
      if (location.state.showModal && !modal) {
        toggleModal();
      }
    }

    //logic of getting coins and getting favourite coins //
    if (!favouriteCoins && userData) {
      getUser(2);
    }

    // saveLastVisitedRouteInLocalStorage(location.pathname);
    if (coinQuery !== "") {
      setClose(false);
      setOpenSearch(true);
      localStorage.getItem("searchedItems") &&
        setSearchedItems([...getSearchedItemsFromLocalStorage()]);
    }
    if (coinQuery === "") {
      setClose(true);
      setOpenSearch(false);
    }
    searchCoins(coinQuery);
    //eslint-disable-next-line
  }, [coinQuery, history, location, userData]);

  // useEffect(() => {
  //   if (vtradingMessage) {
  //     setAlert({ msg: vtradingMessage, color: "white", bgColor: "green" });
  //     clearError();
  //     clearMessage();
  //   }
  //   if (vtradingError) {
  //     setAlert({ msg: vtradingError, color: "white", bgColor: "red" });
  //     clearError();
  //     clearMessage();
  //   }
  //   if (tradathon_vtradingMessage) {
  //     setAlert({
  //       msg: tradathon_vtradingMessage,
  //       color: "white",
  //       bgColor: "green",
  //     });
  //     clearTradathonError();
  //     clearTradathonMessage();
  //   }
  //   if (tradathon_vtradingError) {
  //     setAlert({
  //       msg: tradathon_vtradingError,
  //       color: "white",
  //       bgColor: "red",
  //     });
  //     clearTradathonError();
  //     clearTradathonMessage();
  //   }
  // }, [
  //   vtradingError,
  //   vtradingMessage,
  //   tradathon_vtradingMessage,
  //   tradathon_vtradingError,
  // ]);
  const handleLogOut = () => {
    setOpenDropdown(false);
    logoutUser();
  };
  const handleSearchItemClick = (item) => {
    if (item?.name) saveSearchedItemInLocalStorage(item);
    setOpenSearch(!openSearch);
    setCoinQuery("");
  };
  const { pathname } = useLocation();
  const handleInputClose = () => {
    setClose((prev) => !prev);
    setCoinQuery("");
  };
  return show ? (
    <>
      {modal && <Auth />}
      <div className="Appbar">
        <Toaster />

        <div className="Appbar__container">
          <div className="Appbar__logo__container">
            <div className="Appbar__logo">
              <img src={logo} alt="coinstorey-logo" />
            </div>
            <p className="Appbar__company">CoinStorey</p>
          </div>

          <ul>
            <li>
              <NavLink to="/" activeClassName="Appbar__linkitems" exact>
                Cryptos
              </NavLink>
            </li>
            <li>
              <NavLink to="/vtrading" activeClassName="Appbar__linkitems">
                V-Trading
              </NavLink>
            </li>
            <li>
              <NavLink to="/tradathon" activeClassName="Appbar__linkitems">
                Tradathon
              </NavLink>
            </li>
            {/* <li>
              <NavLink to="/coinlearn" activeClassName="Appbar__linkitems">
                CoinLearn
              </NavLink>
            </li> */}
            <li
            // onClick={() => setOpenMoreDropdown((prev) => !prev)}
            >
              <NavLink
                to="/news"
                activeClassName="Appbar__linkitems"
                isActive={() => ["/news", "/exchanges"].includes(pathname)}
              >
                <span>News | Events</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/faq" activeClassName="Appbar__linkitems">
                &nbsp;FAQ&nbsp;
              </NavLink>
            </li>
          </ul>
          <div className="Appbar__rightcomponents">
            <div className="Appbar__bookmarkicon">
              <FaRegBookmark
                size={16}
                className="Appbar__boomark"
                style={{ cursor: "pointer" }}
                onClick={() => history.push("/favourite")}
              />
              {favouriteCoins && favouriteCoins.length > 0 ? (
                <span className="badge">{favouriteCoins.length}</span>
              ) : (
                <></>
              )}
            </div>
            <div className="Appbar__inputcontainer">
              <input
                type="text"
                placeholder="&#xF002; &nbsp; Type Here To Search"
                value={coinQuery}
                onChange={(e) => setCoinQuery(e.target.value)}
              />
              <IoMdClose
                style={{
                  height: "41px",
                  width: "18px",
                  marginTop: "3px",
                  cursor: "pointer",
                  paddingRight: "3px",
                  display: close ? "none" : "block",
                }}
                onClick={handleInputClose}
              />
            </div>

            {openSearch ? (
              <div className="Appbar__search__dropdown" style={{ zIndex: 2 }}>
                <div className="Appbar__search__dropdown__section">
                  {filteredCryptoData && filteredCryptoData.length > 0 ? (
                    filteredCryptoData.map((d, index) => (
                      <Link to={`/cryptos/${d.id}`}>
                        <div
                          className="Appbar__search__dropdown__container"
                          onClick={() =>
                            handleSearchItemClick({
                              logo_url: d.logo_url,
                              name: d.name,
                              id: d.id,
                            })
                          }
                        >
                          <img src={d.logo_url} alt={d.name} />
                          <p>
                            {d.id} {d.name}
                          </p>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <p>No results found</p>
                  )}
                </div>
                <b>Recent Searches</b>
                <div className="Appbar__search__dropdown__section">
                  {searchedItems && searchedItems.length > 0 ? (
                    searchedItems.map((d, index) => (
                      <>
                        <Link to={`/cryptos/${d.id}`}>
                          <div
                            className="Appbar__search__dropdown__container"
                            onClick={handleSearchItemClick}
                          >
                            <img src={d.logo_url} alt={d.name} />
                            <p>
                              {d.id} {d.name}
                            </p>
                          </div>
                        </Link>
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              <></>
            )}

            {userData?.profile_data ? (
              <div
                className="Appbar__auth"
                onMouseEnter={() => setOpenDropdown((prev) => !prev)}
                onMouseLeave={() => setOpenDropdown((prev) => !prev)}
              >
                {/* {openDropdown ? ( */}
                <div className="Appbar__profile__transparent">
                  {/* <div className="Appbar__profile__dropdown__triangle"></div> */}
                  <div className="Appbar__profile__dropdown">
                    <ul id="Appbar__profile__list">
                      {/* <li
                          style={{ cursor: "pointer" }}
                          onClick={() => setOpenDropdown(false)}
                        >
                          <HiOutlineBell size={30} />
                          Notifications
                        </li>
                        <li
                          style={{ cursor: "pointer" }}
                          onClick={() => setOpenDropdown(false)}
                        >
                          <HiLink size={30} />
                          Connections
                        </li>
                        <li
                          style={{ cursor: "pointer" }}
                          onClick={() => setOpenDropdown(false)}
                        >
                          <BsFillChatDotsFill size={30} />
                          Chatbox
                        </li> */}
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          history.push("/profile");
                          setOpenDropdown(false);
                        }}
                      >
                        <BsFillPersonFill size={30} />
                        Profile
                      </li>
                      <li
                        onClick={handleLogOut}
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        <GoSignOut size={30} />
                        Sign Out
                      </li>
                    </ul>
                  </div>
                </div>
                {/* ) : (
                  <></>
                )} */}
                <img src={userData.profile_data.avatar} alt="avatar" />
                <span title={userData.profile_data.userName}>
                  {userData.profile_data.userName}
                </span>
              </div>
            ) : (
              <button className="Register__button" onClick={toggleModal}>
                <pre>SIGN IN</pre>{" "}
              </button>
            )}
            <div
              className="Home__HamburgerIcon"
              onClick={() =>
                setDisplayBlock((prev) => (prev === "block" ? "none" : "block"))
              }
            >
              {displayBlock === "none" ? (
                <HiMenu
                  size={26}
                  style={{ color: "white", cursor: "pointer" }}
                />
              ) : (
                <MdClose
                  size={26}
                  style={{ color: "white", cursor: "pointer" }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="Appbar__Mobile" style={{right:displayBlock}}>*/}{" "}
      <div className="Appbar__Mobile" style={{ display: displayBlock }}>
        <div className="Appbar__Mobile__container">
          <div className="Appbar__Mobile__inputcontainer">
            <input
              type="text"
              placeholder="&#xF002; &nbsp; Type Here To Search"
              value={coinQuery}
              onChange={(e) => setCoinQuery(e.target.value)}
            />
            <IoMdClose
              style={{
                height: "41px",
                width: "18px",
                marginTop: "3px",
                cursor: "pointer",
                paddingRight: "3px",
                display: close ? "none" : "block",
              }}
              onClick={handleInputClose}
            />
          </div>

          <ul>
            <li
              onClick={() =>
                setDisplayBlock((prev) => (prev === "block" ? "none" : "block"))
              }
            >
              <NavLink to="/" activeClassName="Appbar__linkitems" exact>
                Cryptos
              </NavLink>
            </li>
            <li
              onClick={() =>
                setDisplayBlock((prev) => (prev === "block" ? "none" : "block"))
              }
            >
              <NavLink to="/vtrading" activeClassName="Appbar__linkitems">
                V-Trading
              </NavLink>
            </li>
            <li
              onClick={() =>
                setDisplayBlock((prev) => (prev === "block" ? "none" : "block"))
              }
            >
              <NavLink to="/tradathon" activeClassName="Appbar__linkitems">
                Tradathon
              </NavLink>
            </li>
            {/* <li
              onClick={() =>
                setDisplayBlock((prev) => (prev === "block" ? "none" : "block"))
              }
            >
              <NavLink to="/coinlearn" activeClassName="Appbar__linkitems">
                CoinLearn
              </NavLink>
            </li> */}
            <li>
              <NavLink
                to="/news"
                activeClassName="Appbar__linkitems"
                onClick={() => setOpenMoreDropdown((prev) => !prev)}
              >
                <span className="Appbar__Mobile__more">
                  <span>News & Events</span>
                  {/* {openMoreDropdown ? (
                    <BiChevronUp size={24} />
                  ) : (
                    <BiChevronDown size={24} />
                  )} */}
                </span>
              </NavLink>
            </li>{" "}
            <li
              onClick={() =>
                setDisplayBlock((prev) => (prev === "block" ? "none" : "block"))
              }
            >
              <NavLink to="/faq" activeClassName="Appbar__linkitems">
                FAQ
              </NavLink>
            </li>
            {/* {openMoreDropdown ? (
              <>
                {" "}
                <li
                  onClick={() =>
                    setDisplayBlock((prev) =>
                      prev === "block" ? "none" : "block"
                    )
                  }
                >
                  <NavLink to="/news" activeClassName="Appbar__linkitems">
                    News
                  </NavLink>
                </li>
                <li
                  onClick={() =>
                    setDisplayBlock((prev) =>
                      prev === "block" ? "none" : "block"
                    )
                  }
                >
                  <NavLink to="/exchanges" activeClassName="Appbar__linkitems">
                    Exchanges & Events
                  </NavLink>
                </li>
              </>
            ) : (
              <></>
            )} */}
          </ul>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default withRouter(Appbar);
